import React from 'react';
import { useInView } from "react-intersection-observer";

export default function SubHeroComp() {

    const { ref, inView } = useInView({
    triggerOnce: true, // animate only once
    threshold: 0.1,    // 10% visible triggers
  });

  return (
    <div
      ref={ref}
      className={`relative w-full mx-auto px-4 sm:px-10 pt-10 my-12 bg-white 
         overflow-hidden ${
           inView ? "animate-fadeInUp" : "opacity-0 translate-y-8"
         }`}
      style={{ transition: "opacity 0.6s ease, transform 0.6s ease" }}
    >

      {/* content-1 */}
      <div className="mb-4 text-center">
        <span className="font-bold uppercase text-sky-700 text-[15px] tracking-wide">
          {/* You’re not alone in a crisis. You’re with experts. */}
            You’re not alone in a crisis.{" "}
            <span className="block md:hidden" />
                You’re with experts.
        </span>
      </div>
      
      {/* content-2 */}
      <div className="mb-6 text-center">
        <span className="font-semibold uppercase text-[15px] tracking-wider text-sky-700">
          {/* We understand emergencies. We're here for you. */}
            We understand emergencies.{" "}
            <span className="block md:hidden" /> 
                We're here for you.
        </span>
      </div>
      <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-sky-900 text-center leading-tight mb-6">
        {/* <span className="text-[#007d4d]"> Life rarely waits. </span><br  /> */}
        <span className="text-sky-600"> Life rarely waits. </span><br  />
        Rapid response, trusted service.<br />
        Your safety, our mission.
      </h2>
      <p className="text-lg sm:text-xl text-gray-700 text-center font-medium max-w-2xl mx-auto mb-2">
        In every crisis, time matters. Our trained ambulance teams are always ready—bringing unmatched care, advanced vehicles, and local expertise to your doorstep.
      </p>
      <p className="text-base text-slate-500 text-center max-w-2xl mx-auto mb-3">
        Let us guide you through uncertainty. Decentralized, 24/7 support, so help is closer than ever before. Our community trusts us—because we never compromise on your comfort, safety, or dignity.
      </p>
      
    </div>
  );
}
